//https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/components/modal.ts
import { modalAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  modalAnatomy.keys
);

const sizes = {
  md: definePartsStyle({
    dialog: {
      maxW: ['100vw', '50vw'],
      margin: [4, 0]
    },
    body: { fontSize: 'md' }
  })
};

export const modalTheme = defineMultiStyleConfig({ sizes });
